/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function language() {
    const languageSelectors = document.querySelectorAll(".language-selector");
    const visibleClass = "language-selector--visible";

    const toggleLanguageSelector = function(languageSelector, forceClose = false) {
        if (languageSelector != null) {
            if (forceClose) {
                languageSelector.classList.remove(visibleClass);
            } else if (!languageSelector.classList.contains(visibleClass)) {
                languageSelector.classList.add(visibleClass);
            } else {
                languageSelector.classList.remove(visibleClass);
            }
        }
    };

    const init = function () {
        languageSelectors.forEach(languageSelector => {
            languageSelector.querySelector('.language-selector__current').addEventListener('click', e => {
                e.stopPropagation(); // Prevent the click event from propagating to the document
                toggleLanguageSelector(languageSelector);
            });

            document.addEventListener('click', e => {
                if (!e.target.closest('.language-selector')) {
                    toggleLanguageSelector(languageSelector, true);
                }
            });
        });
    };

    init();
}

